// extracted by mini-css-extract-plugin
export var messageSideLeft = "_og-1";
export var stateContainer = "_og-0";